import { useTheme as useEmotionTheme } from '@emotion/react'

// import { Theme } from 'styles/theme'

export const useTheme = () => useEmotionTheme()
